const Content = ({ children }: { children: any }) => {
  return (
    <div className="bg-[#FFFDE7] pt-[70px] lg:pt-[100px]">
      <div className="w-full text-[#050C29]">{children}</div>
    </div>
  )
}
export default Content
